import { hasCrmPermissions } from "app/components/SideBar/utils";
import { SI_ROOT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import {
    DYNAMICS_MANAGEMENT_MANAGE_ROUTE,
    DYNAMICS_MANAGEMENT_MANAGE_URL,
    DYNAMICS_MANAGEMENT_ROOT_ROUTE_EXPORT,
} from "app/pages/sales-intelligence/constants/sl_routes";
import ManageExport from "app/pages/sales-intelligence/pages/manage-export/ManageExport";
import ManageIntegration from "app/pages/sales-intelligence/pages/manage-integration/ManageIntegration";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const dynamicsConfig: RouterStateConfig = {
    [DYNAMICS_MANAGEMENT_MANAGE_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: DYNAMICS_MANAGEMENT_MANAGE_URL,
        component: ManageIntegration,
        configId: "SalesWorkspace",
        stateId: DYNAMICS_MANAGEMENT_MANAGE_ROUTE,
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "manage dynamics",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
    [DYNAMICS_MANAGEMENT_ROOT_ROUTE_EXPORT]: {
        parent: SI_ROOT_ROUTE,
        url: `${DYNAMICS_MANAGEMENT_MANAGE_URL}/export`,
        component: ManageExport,
        configId: "SalesWorkspace",
        trackingId: {
            section: "dynamics management",
            subSection: "",
            subSubSection: "",
        },
        pageTitle: "si.pages.management.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceManagement" as SecondaryBarType,
        isHidden: hasCrmPermissions(),
    },
};
